import { jsx as _jsx } from "react/jsx-runtime";
import { getIsKpiValueBasedGoalTarget } from '../../../../utils/goalTarget';
import PercentProgress from './GoalPercentProgress';
import KpiProgress from './KpiProgress';
export default function ProgressCell({
  goalTarget
}) {
  const {
    goalType
  } = goalTarget;
  const isKpiValueBasedGoal = getIsKpiValueBasedGoalTarget(goalType);

  if (isKpiValueBasedGoal) {
    return /*#__PURE__*/_jsx(KpiProgress, {
      goalTarget: goalTarget
    });
  }

  return /*#__PURE__*/_jsx(PercentProgress, {
    goalTarget: goalTarget
  });
}